import React, { useState } from "react";
import { Button, Grid, DropdownButton, Dropdown, DropdownItem, DropdownMenu} from "@deere/fuel-react";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { DEFAULT_LANGUAGE } from "../../utils/surveyLiterals";
import { saveSurveyPartAnswers, getResponsesByAssignmentSurveypart } from "../../services/surveypart.service";
import { getSuppSurveyConfiguration } from '../../services/userService';
import Cookies from "js-cookie";
import { getSurveyLiterals } from "../../services/survey.service";
import { getSectionsWithErrors, valPartAndSuppSURVEYPART} from '../../utils/validation';
import { getHelpDocPdfBySurveyId } from "../../services/surveyHelpDoc.service";
import { ModalDocument } from "../../components/modals/ModalDocument";
import { GenericFuelModal } from "../../components/modals/GenericFuelModal";
import { useSelector } from 'react-redux';
import { uploadSurveyFile } from "../../utils/saveSurveyUtils";
import { useUserInfo } from "../../providers/userProvider";
import { useOktaAuth } from '@okta/okta-react'

const ButtonSection = ({ surveyData, campaign, survey, setSurvey, setLiterals, clearFunction, setIsSubmitted,setErrorCard, errorCard, sections, setValidated,surveyForm , setSuccessMessage, setSurveyPartResponse, setUrl, url, setPartErrorIds, setResponseSelected, isAuthMethodOkta, token, submitResponse, setSaveButtonClickFlag, surveyLanguages, uploadedFiles}) => {

  const { t } = useTranslation();
  const [currentLanguageCode, setCurrentLanguageCode] = useState(Cookies.get('i18next') || DEFAULT_LANGUAGE);
  const [disableSubmit, setDisableSubmit] = useState(false );
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const suppliers = surveyData.suppliers
  const partAnswers=surveyData.partAnswers;
  const stateList = useSelector(state => state.surveyPartReducer.stateList);
  const userInfo = useUserInfo();
  const { authState } = useOktaAuth();

  const handleSave = async (isSubmit) => {
    if (!surveyData.responseName || !surveyData.responseName.trim()) {
      setErrorCard([t("lbl_error_response_name")]);
      setLoading(false);
      window.scrollTo(0, 0);
      return;
    }
    setLoading(true);
    clearFunction();
    const requestObj = {
      suppliers: surveyData.suppliers,
      assignments: surveyData?.assignments?.map((a) => a.id) ?? [],
      campaignId: surveyData.campaignId,
      responseName: surveyData.responseName,
      partAnswers: surveyData.partAnswers,
      caId: campaign.assignments[0].id,
      responseId: surveyData.responseId,
      answers:
        surveyData.answers.length > 0
          ? surveyData.answers.map((ans) => {
              return { questionId: ans.questionId, answer: ans.answer };
            })
          : [],
    };
    try {
      const res = await saveSurveyPartAnswers(requestObj, token, isAuthMethodOkta);
      const uploadPromises = uploadedFiles
        .filter((file) => file.fileData)
        .map((file) => {
          const fd = new FormData();
          fd.append("file", file.fileData);
          fd.append("content-type", file.fileData.type || "application/octet-stream");
          return uploadSurveyFile(fd, campaign, file.fileNumber, userInfo, authState);
        });
      await Promise.all(uploadPromises);
      if (res && res.id) {
        if (isSubmit) {
          setResponseSelected({ target: { value: res.id.toString() } }, res, true);
        } else {
          getResponsesByAssignmentSurveypart(campaign.assignments[0].id, token, campaign.isNonDeere, isAuthMethodOkta)
            .then((response) => {
              if (response) setSurveyPartResponse(response);
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
          setSuccessMessage(t("lbl_success_save_message"));
          setLoading(false);
          setResponseSelected({ target: { value: res.id.toString() } }, res, false);
          window.scrollTo(0, 0);
          setSaveButtonClickFlag(true);
        }
      } else {
        setErrorCard([t("lbl_error_saving_message")]);
        setLoading(false);
        window.scrollTo(0, 0);
      }
    } catch (err) {
      console.error(err);
      setErrorCard([t("lbl_error_saving_message")]);
    } finally {
      setLoading(false);
      window.scrollTo(0, 0);
    }
  };

const changeLanguage = async (locale) => {
  const langCode = locale.split("_")[0];
  try {
    const survey = await getSuppSurveyConfiguration(campaign.surveyId, langCode, token, isAuthMethodOkta);
    const literals = await getSurveyLiterals(campaign.surveyId, langCode, token, isAuthMethodOkta);
    const helpDoc = await getHelpDocPdfBySurveyId(token, campaign.surveyId, langCode, isAuthMethodOkta);
    if (survey) setSurvey(survey);
    if (literals && Array.isArray(literals)) setLiterals(literals);
    if (helpDoc && helpDoc.response === 200) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setUrl(url);
    }
  } catch (err) {
    console.error(err);
  } finally {
    i18next.changeLanguage(langCode);
    setCurrentLanguageCode(langCode);
  }
};

const handleSubmit = (e) => {
  clearFunction();
  setIsSubmitted(true)  
  let errorSections = getSectionsWithErrors(surveyForm);
  let partQuestionErrorIds = [];
  valPartAndSuppSURVEYPART(Array.isArray(suppliers) ? suppliers : [], Array.isArray(partAnswers) ? partAnswers : [], errorSections, sections, partQuestionErrorIds, stateList);
  if(partQuestionErrorIds.length > 0) setPartErrorIds([...partQuestionErrorIds]);
  setErrorCard(errorSections);

  if (errorCard && errorCard.length > 0) {
      e.preventDefault();
      e.stopPropagation();
  }

  setValidated(true);
  e.preventDefault();
  e.stopPropagation();
  if (surveyForm.checkValidity() && errorSections.length <= 0) {
      setIsSubmitted(false);
      setValidated(false);
      submitResponse ? setShowSubmitModal(true) : handleSave(true);
  }else{
    window.scrollTo(0, 0);
  }
}

  return (
    <>
      <Grid container className="card position-sticky fixed-bottom" >
        {url && <Grid className="card-body p-3 text-left">
          <Button variant="secondary" type="button" onClick={() => setShowModal(true)} >{t('lbl_Help_Doc')}</Button>
        </Grid>}
        <Grid className="card-body p-3 text-right" justifyContent="space-between">
          <span className='mr-2' variant="secondary">
          {(surveyLanguages && surveyLanguages.length > 1) &&<Dropdown size="small">
              <DropdownButton onClick={e => e.preventDefault()}>{t('btn_change_language')} </DropdownButton>
              <DropdownMenu placement="top-start">
                {surveyLanguages.map(({ code, name, country_code }) => (
                      currentLanguageCode === code ? <DropdownItem key={country_code}
                          href="#" className="nav-link active" onClick={e => e.preventDefault()}>
                          <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 0.3 }}></span>{name}
                      </DropdownItem> : <DropdownItem key={country_code}
                          href="#" onClick={() => changeLanguage(code)}>
                          <span className={`flag-icon flag-icon-${country_code} mx-2`} style={{ opacity: 1 }}></span>{name}
                      </DropdownItem>
                  ))}
              </DropdownMenu>
            </Dropdown>
          }
          </span>
          <Button className="mr-2" variant="secondary" type="button" onClick={submitResponse ? () => setShowSaveModal(true) : () => handleSave(false)} disabled={loading}>
            {t("btn_save_survey")}
          </Button>
          <Button className='mr-2' variant="primary" type='submit' onClick={handleSubmit} disabled={disableSubmit || loading}>{t('btn_review')}</Button>
        </Grid>
      </Grid>
      <ModalDocument 
          showModal={showModal}
          setShowModal={setShowModal}
          labelBtnPrimary={t("btn_close")}
          titleModal={t("lbl_Help_Doc")}
          iFrameUrl={url}
      />
      <GenericFuelModal
        title={t("confirm_label")}
        message={t("lbl_edit_response_message")}
        primaryButton={t("btn_OK")}
        show={showSaveModal}
        handleClose={() => setShowSaveModal(false)}
        handleSave={() => {
          setShowSaveModal(false);
          handleSave(false);
        }}
      />
      <GenericFuelModal
        title={t("confirm_label")}
        message={t('lbl_review_and_submit_message')}
        primaryButton={t('btn_yes')}
        secondaryBtn={t('btn_no')}
        show={showSubmitModal}
        handleClose={() => setShowSubmitModal(false)}
        handleSave={() => {
          setShowSubmitModal(false);
          handleSave(true);
        }}
      />
    </>
  );
};

export default ButtonSection;
